<template>
    <div>
        <div class="new_top">
            <div class="ac_one">
                <div class="flex_box">
                    <img class="tip_img" src="/activity/SuperRecharge/img/left.png">
                    <span class="ac_title">活动期间享受充值超高倍率</span>
                    <img class="tip_img" src="/activity/SuperRecharge/img/right.png">
                </div>
                <div class="ac_box">
                    <span class="ac_text">充值100 充值倍率27倍</span>
                    <span class="ac_text">充值200 充值倍率29倍</span>
                    <span class="ac_text">充值300 充值倍率31倍</span>
                    <span class="ac_text">充值500 充值倍率33倍</span>
                    <span class="ac_text">充值1000 充值倍率35倍</span>
                </div>
                <div class="beizhu">
                    <div class="ac_bz">备注:充值≥1000,充值倍率35倍</div>
                    <!-- 背景 -->
                    <img class="time_bg" src="/activity/SuperRecharge/img/time1.png">
                </div>
                <div class="beizhu">
                    <div class="ac_bz">备注：此次活动全额充值额度不包含转区点，绝无套路！！！</div>
                    <!-- 背景 -->
                    <img class="time_bg1" src="/activity/SuperRecharge/img/time.png">
                </div>
                <img class="djcz_btn btn_hover" src="/activity/SuperRecharge/img/djcz.png" @click="toReach">
            </div>
            <!-- 背景 -->
          <img class="bg" src="/activity/SuperRecharge/img/bg.png">
        </div>
    </div>
</template>

<script>
import { auto } from "@popperjs/core";
export default {
    name: 'SuperRecharge',
    data() {
      return {
        isClick: true, //防抖
        isactive:false, //活动是否开启
        money:'',
        bag_num:0,
      }
    },
    methods: {
        toReach(){
            this.$router.push({
                path:'/member/wallet'
            })
        },
    },
    created(){
    }
}
</script>

<style scoped>
.ac_box{
    display: flex;
    flex-direction: column;
    align-items: start;
}
.beizhu{
    position: relative;
    margin-top: 17px;
}
.time_bg{
    width: 631px;
}
.time_bg1{
    width: 895px;
}
    .tip_img{
        width: 94px;
    }
    .new_top{
        padding-top: 368px;
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        left: 0;
        top: 0;
    }
    .bg {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -99;
        width: 100%;
    }
    .activity_box{
        position: relative;
    }
    .ac_one{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        left: 13%;
    }
    .ac_title{
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 28px;
        color: #A11717;
        background: linear-gradient(0deg, #370810 0%, #CB191E 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 0 10px;
    }
    .ac_text{
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 22px;
        position: relative;
        display: inline-block;
        color: #43670A;
        background: linear-gradient(0deg, #370810 0%, #CB191E 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-top: 10px;
    }
    .ac_bz{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        font-family: Source Han Sans SC;
        font-weight: bold;
        font-size: 24px;
        color: #FBFFB3;
        background: linear-gradient(0deg, #FFEC95 25.68359375%, #FFFEE6 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        letter-spacing: 2px;
        width: 100%;
        text-align: center;
    }
    .djcz_btn{
        margin-top: 30px;
        width: 352px;
    }
    .ac_title2{
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 28px;
        color: #FFFFFF;
        line-height: 29px;
        background: linear-gradient(0deg, #86081D 0%, #CB191E 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .bag_img{
        margin-top: 15px;
    }
    .ac_num{
        font-family: Source Han Sans SC;
        font-weight: bold;
        font-size: 24px;
        color: #A81212;
    }

</style>